import { Button, CircularProgress, createStyles, makeStyles, Typography } from '@material-ui/core';
import React, { useState } from 'react';
import { useDocumentData, useDocumentViewerApi, useLocalization } from "../hooks/index.js";
const useStyles = makeStyles(() => {
  return createStyles({
    mainWrapper: {
      display: 'flex',
      justifyContent: 'space-around',
      alignContent: 'center',
      alignItems: 'center',
      height: '100%'
    },
    regenerateWrapper: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      flexDirection: 'column',
      maxWidth: 500,
      margin: '.5em 0 .6em 0'
    }
  });
});
export const DocumentViewerRegeneratePreviews = () => {
  const classes = useStyles();
  const [isRegenerating, setIsRegenerating] = useState(false);
  const localization = useLocalization();
  const api = useDocumentViewerApi();
  const {
    documentData,
    updateDocumentData,
    isInProgress,
    triggerReload
  } = useDocumentData();
  /**
   * renders the component
   */

  return /*#__PURE__*/React.createElement("div", {
    className: classes.mainWrapper
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.regenerateWrapper
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "subtitle1",
    color: "textSecondary",
    align: "center",
    gutterBottom: true
  }, localization.regeneratePreviews), /*#__PURE__*/React.createElement(Button, {
    variant: "contained",
    disabled: isRegenerating || isInProgress,
    onClick: async () => {
      setIsRegenerating(true);
      const result = await api.regeneratePreviews({
        document: documentData,
        abortController: new AbortController()
      });
      updateDocumentData({ ...documentData,
        pageCount: result.PageCount
      });
      setIsRegenerating(false);
      triggerReload();
    }
  }, isRegenerating && /*#__PURE__*/React.createElement(CircularProgress, {
    size: 24,
    style: {
      marginRight: '1em'
    }
  }), localization.regenerateButton)));
};
//# sourceMappingURL=document-viewer-regenerate-previews.js.map